import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { UnitSelectionGuard } from './guard/unit-selection.guard';
import { UnitListComponent } from './unit-list/unit-list.component';
import { UnitSelectionListComponent } from './unit-selection-list.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        UnitSelectionListComponent: {
          component: UnitSelectionListComponent,
          guards: [UnitSelectionGuard],
        },
      },
    } as CmsConfig),
    UnitSelectionListComponent,
    UnitListComponent,
  ],
  exports: [UnitSelectionListComponent],
})
export class UnitSelectionListModule {}
